import i18n from 'i18next';
import { CountryCode } from '../enums/CountryCode';
import HttpBackend, { HttpBackendOptions } from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';

// import Backend from 'i18next-http-backend';
// import LanguageDetector from 'i18next-browser-languagedetector';
// don't want to use this?
// have a look at the Quick start guide
// for passing in lng and translations on init

i18n
    // load translation using http -> see /public/locales (i.e. https://github.com/i18next/react-i18next/tree/master/example/react/public/locales)
    // learn more: https://github.com/i18next/i18next-http-backend
    // want your translations to be loaded from a professional CDN? => https://github.com/locize/react-tutorial#step-2---use-the-locize-cdn
    // .use(Backend)
    // detect user language
    // learn more: https://github.com/i18next/i18next-browser-languageDetector
    // .use(LanguageDetector)
    // pass the i18n instance to react-i18next.
    .use(initReactI18next)
    .use(HttpBackend)
    // init i18next
    // for all options read: https://www.i18next.com/overview/configuration-options
    .init<HttpBackendOptions>({
        backend: {
            loadPath: `${process.env.REACT_APP_ADMIN_API_BASE_URL}/translations/locales/{{lng}}/translation.json`,
        },
        fallbackLng: CountryCode.ENGLISH,
        lng: CountryCode.ENGLISH,
        debug: false,
        interpolation: { escapeValue: false },
        react: { useSuspense: false }, //this line needed to prevent App Suspense error
    });

export default i18n;
